import type { AxiosRequestConfig } from 'axios';

import type { ProductAPI } from '~/api/Catalog';
import { ENDPOINT } from '~/api/constants';
import { RequestAPI } from '~/api/Requests';
import { getLangHeaders } from '~/api/utils';

import type { BackorderLogic } from './BacorderLogic';

export interface StockSubscriptionResponse {
  data: {
    id: string;
    customerId: string;
    sku: string;
    productId: number;
    warehouseCode: string;
    categoryId: number;
    companyId: string;
    subscriptionDate: string;
    notificationCount: number;
    status: string;
  };
}

export const StockSubscriptionsRequests = {
  addSubscription: (
    productId: number,
    sku: string,
    warehouseCode: string,
    availableNow: boolean,
    backorderLogic: BackorderLogic,
    options?: AxiosRequestConfig,
  ): Promise<StockSubscriptionResponse> =>
    RequestAPI.post(
      ENDPOINT.stockSubscriptions.addSubscription,
      {
        productId,
        sku,
        warehouseCode,
        availableNow,
        backorderLogic,
      },
      options,
    ),

  deleteSubscription: (
    productId: number,
    sku: string,
    warehouseCode: string,
    options?: AxiosRequestConfig,
  ): Promise<void> =>
    RequestAPI.post(
      ENDPOINT.stockSubscriptions.deleteSubscription,
      {
        productId,
        sku,
        warehouseCode,
      },
      options,
    ),

  getSubscriptions: (
    page: number = 1,
    size: number = 20,
    warehouseCode?: string,
  ): Promise<{
    data: ProductAPI[];
    pagination: {
      total: number;
      current: number;
      size: number;
    };
  }> =>
    RequestAPI.get(
      ENDPOINT.stockSubscriptions.getSubscriptions,
      {
        'pagination[page]': page,
        'pagination[size]': size,
        ...(warehouseCode ? { warehouseCode } : {}),
      },
      getLangHeaders(),
    ),

  getSubscriptionsSKU: (
    warehouseCode: string,
  ): Promise<Record<string, string[]>> =>
    RequestAPI.get(ENDPOINT.stockSubscriptions.getSubscriptionsSKU, {
      warehouseCode,
    }),
};
